import {SvgIcon, SvgIconProps} from "@mui/material";
import React from "react";

export const MicrosoftIcon = (props: SvgIconProps) => (
  <SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 439 439"  {...props}>
    <path fill="#f3f3f3" d="M0 0H439V439H0z"></path>
    <path fill="#F35325" d="M17 17H211V211H17z"></path>
    <path fill="#81BC06" d="M228 17H422V211H228z"></path>
    <path fill="#05A6F0" d="M17 228H211V422H17z"></path>
    <path fill="#FFBA08" d="M228 228H422V422H228z"></path>
  </SvgIcon>
);
